import React from "react";
import PageHeaderWrapper from "../../components/PageHeaderWrapper";
import { connect } from "react-redux";
import { Card, Row, Col, DatePicker, Popover, Spin, Switch, Icon, Select, Divider, Tooltip, Badge, Input, Empty, Statistic, Drawer, Button, Tag } from "antd";
import moment from "moment";
import Request from "../../request";
import { TableComp } from "sz-react-utils";

const { RangePicker } = DatePicker;
const { Option } = Select;

const VIEW_TYPES = ["Monthly", "Yearly"];

let desks = {
    'Front Desk': '/desk/update-counselling',
    'Registration Desk': '/registration/fees',
    'Application Desk': '/desk/allApplication-desk/update',
    'Visa Desk': '/desk/getVisa',
    'Claim Desk': '/desk/getClaim',
    'Operation Manager Desk': '/operation-manager-inquiry/update'
};

class VisaApprovedStudents extends React.Component {
    state = {
        visible: true,
        loading: false,
        data: []
    }

    onClose = () => {
        this.setState({ visible: false });
        setTimeout(() => {
            this.props.onClose();
        }, 300);
    }

    getData = async () => {
        const params = this.props.params;
        this.setState({ loading: true });

        const response = await Request.getVisaApprovedStudentReport(params);

        this.setState({
            data: response && response.data ? response.data : [],
            loading: false
        });
    }

    componentDidMount() {
        this.getData();
    }

    // ✅ SEARCH FUNCTION
    getColumnSearchProps = (fields) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    placeholder="Search"
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => confirm()}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => confirm()}
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
                </Button>
                <Button
                    onClick={() => clearFilters()}
                    size="small"
                    style={{ width: 90 }}
                >
                    Reset
                </Button>
            </div>
        ),

        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),

        onFilter: (value, record) => {
            const search = value.toLowerCase();

            return fields.some(field => {
                const fieldValue = field(record);

                return fieldValue &&
                    fieldValue.toString().toLowerCase().includes(search);
            });
        }
    });

    // ✅ EXPORT CSV
    exportToCSV = () => {
        const { data } = this.state;
        if (!data || !data.length) return;

        // ✅ CSV escape (handles quotes, nulls, numbers)
        const escapeCSV = (value) => {
            if (value === null || value === undefined) return "";
            const str = value.toString().replace(/"/g, '""');
            return `"${str}"`;
        };

        const headers = [
            "Student Name",
            "VID",
            "Passport",
            "Country",
            "University",
            "Visa Approval Date",
            "Branch",
            "Associate Partner",
            "Source Type"
        ];

        const rows = data.map(item => {
            let university = item.university || "";
            const country = item.country || "";

            // ✅ Remove duplicate country from university
            if (country && university.includes(country)) {
                university = university.replace(new RegExp(`,?\\s*${country}$`), "");
            }

            return [
                escapeCSV(item.studentName),
                escapeCSV(item.vid || ""), // ✅ VID SAFE
                escapeCSV(item.passportNumber),
                escapeCSV(country),
                escapeCSV(university.trim()),
                escapeCSV(item.visaApprovalDate),
                escapeCSV(item.branchName),
                escapeCSV(item.associatePartner),
                escapeCSV(item.sourceType)
            ];
        });

        const csvContent =
            "data:text/csv;charset=utf-8,\uFEFF" + // ✅ Excel UTF-8 fix
            [headers.map(escapeCSV), ...rows]
                .map(row => row.join(","))
                .join("\n");

        const link = document.createElement("a");
        link.href = encodeURI(csvContent);
        link.download = `Visa_Approved_Students_${Date.now()}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    render() {
        const { visible, loading, data } = this.state;

        const columns = [
            {
                title: "Student Details",
                key: "student",
                ...this.getColumnSearchProps([
                    r => r.studentName,
                    r => r.vid,
                    r => r.passportNumber
                ]),
                render: (text, record) => (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span style={{ fontWeight: 600, color: '#1890ff', cursor: 'pointer' }} onClick={() => window.open(`${desks[record.atLevel]}?id=${record.id}`, '_blank')}>
                            {record.studentName || "N/A"}
                        </span>
                        <small><b>VID:</b> {record.vid || "N/A"}</small>
                        <small style={{ color: '#8c8c8c' }}>
                            <Icon type="file-text" style={{ fontSize: '10px' }} /> {record.passportNumber || "No Passport"}
                        </small>
                    </div>
                )
            },
            {
                title: "Institution / Location",
                key: "institution",
                ...this.getColumnSearchProps([
                    r => r.university,
                    r => r.country
                ]),
                render: (text, record) => (
                    <div>
                        <div>{record.university}</div>
                        <div style={{ fontSize: '12px', color: '#8c8c8c' }}>
                            <Icon type="environment" /> {record.country}
                        </div>
                    </div>
                )
            },
            {
                title: "Approval Date",
                dataIndex: "visaApprovalDate",
                key: "visaApprovalDate",
                align: 'center',
                ...this.getColumnSearchProps([
                    r => r.visaApprovalDate,
                    r => moment(r.visaApprovalDate, "DD-MM-YYYY").format("DD MMM YYYY")
                ]),
                render: (date) => (
                    <span style={{ color: '#52c41a', fontWeight: 600 }}>
                        {date ? moment(date, "DD-MM-YYYY").format('DD MMM, YYYY') : "N/A"}
                    </span>
                )
            },
            {
                title: "Source & Partner",
                key: "source",
                ...this.getColumnSearchProps([
                    r => r.branchName,
                    r => r.associatePartner
                ]),
                render: (text, record) => (
                    <div>
                        <Tag color="blue">{record.branchName || "Main Branch"}</Tag>
                        {record.associatePartner && (
                            <div style={{ fontSize: '11px', color: '#8c8c8c' }}>
                                <b>Partner:</b> {record.associatePartner}
                            </div>
                        )}
                    </div>
                )
            },
            {
                title: 'Consultancy Details',
                key: 'registrationDesk',
                dataIndex: 'registrationDesk',
                width: 150,
                render: (item, record) => {
                    const hasBalance = item && item.balance !== null && item.balance !== undefined;
                    const bgBalance = hasBalance && item.balance > 0
                        ? { background: 'red', color: 'white', padding: '10px', borderRadius: '4px' }
                        : {};

                    return (
                        <div>
                            {hasBalance ? (
                                <>
                                    <div><b>Balance:</b> {item.balance}</div>
                                </>
                            ) : (
                                <div style={{ color: '#8c8c8c' }}>No Data</div>
                            )}

                            {/* {hasBalance && item.balance > 0 && (
                                <Button
                                    size="small"
                                    style={{ marginTop: 5 }}
                                    onClick={() => this.openPayNow(record)}
                                >
                                    Recv Now
                                </Button>
                            )} */}
                        </div>
                    );
                }
            },
            {
                title: 'Commmission Status',
                key: 'invoiceStatus',
                render: (text, record) => {
                    const invoices = record.nextInvoiceGenerationDates || [];

                    if (!invoices.length) {
                        return <span style={{ color: '#8c8c8c' }}>No Data</span>;
                    }

                    // Latest invoice for main tag
                    const latest = invoices[invoices.length - 1];

                    let status = "Pending";
                    let color = "#faad14";

                    if (latest.invoiceStatus) {
                        status = latest.invoiceStatus;
                        color = latest.invoiceStatus === "Cleared" ? "#52c41a" : "#1890ff";
                    } else if (latest.invoiceGenerated) {
                        status = "Generated";
                        color = "#1890ff";
                    }

                    // Popover content (Term-wise details)
                    // const content = (
                    //     <div style={{ minWidth: 180 }}>
                    //         {invoices.map((inv, i) => {
                    //             let s = "Pending";

                    //             if (inv.invoiceStatus) {
                    //                 s = inv.invoiceStatus;
                    //             } else if (inv.invoiceGenerated) {
                    //                 s = "Generated";
                    //             }

                    //             return (
                    //                 <div key={i} style={{ marginBottom: 6 }}>
                    //                     <b>Term {inv.invoiceNo}:</b> {s}
                    //                 </div>
                    //             );
                    //         })}
                    //     </div>
                    // );
                    const content = (
                        <div style={{ minWidth: 220 }}>
                            {invoices.map((inv, i) => {
                                const isGenerated = inv.invoiceGenerated;
                                const invStatus = inv.invoiceStatus || (isGenerated ? "Generated" : "Pending");

                                return (
                                    <div key={i} style={{
                                        padding: '8px 0',
                                        borderBottom: i !== invoices.length - 1 ? '1px solid #f0f0f0' : 'none',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }}>
                                        <div>
                                            <div style={{ fontSize: '12px', fontWeight: 600 }}>
                                                Term {inv.invoiceNo || (i + 1)}
                                            </div>
                                            {inv.invoiceGeneratedNumber && (
                                                <div style={{ fontSize: '11px', color: '#8c8c8c' }}>
                                                    INV No.: {inv.invoiceGeneratedNumber}
                                                </div>
                                            )}
                                        </div>
                                        <Tag color={invStatus === "Cleared" ? "green" : isGenerated ? "blue" : "orange"} style={{ fontSize: '10px', marginRight: 0 }}>
                                            {invStatus}
                                        </Tag>
                                    </div>
                                );
                            })}
                        </div>
                    );

                    return (
                        <Popover content={content} title="Invoice Details" trigger="hover">
                            <Tag color={color} style={{ cursor: 'pointer' }}>
                                {status}
                            </Tag>
                        </Popover>
                    );
                }
            },
        ];

        return (
            <Drawer
                title={
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: '100%', paddingRight: '20px' }}>
                        <div>
                            <span style={{ fontWeight: 700, fontSize: '18px' }}>Visa Approved Students</span>
                            <Badge
                                count={data.length}
                                style={{ backgroundColor: '#52c41a', marginLeft: 12, boxShadow: 'none' }}
                                overflowCount={9999}
                            />
                        </div>

                        <Button
                            type="primary"
                            ghost
                            icon="download"
                            onClick={this.exportToCSV}
                            disabled={loading || data.length === 0}
                        >
                            Export CSV
                        </Button>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={950}
                visible={visible}
                bodyStyle={{ padding: '0px' }}
            >
                {loading ? (
                    <div style={{ textAlign: "center", padding: "100px 0" }}>
                        <Spin size="large" tip="Loading..." />
                    </div>
                ) : (
                    <TableComp
                        columns={columns}
                        dataSource={data}
                        rowKey={(record, index) => record.id || index}
                        size="middle"
                        pagination={{
                            pageSize: 15,
                            showTotal: (total) => `Total ${total} students`
                        }}
                    />
                )}
            </Drawer>
        );
    }
}




class VisaApprovalReport extends React.Component {
    state = {
        time: { from: null, to: null },
        loading: false,
        viewType: null,
        report: null, // Timeline data (Top Table)
        selectedPeriod: null,
        branchReport: null, // Branch data (Bottom Table)
        selectedBranch: null,
        exportParams: null,
        exportParams: null,
        showStudentDrawer: false,
        typeView: "branch",
        countries: {},
    }

    chooseRangerPicker = (date) => {
        if (!date || date.length < 2) {
            this.setState({ time: { from: null, to: null }, report: null, branchReport: null });
            return;
        }

        const time = {
            from: moment(date[0]).startOf("day"),
            to: moment(date[1]).endOf("day")
        };

        this.setState({ time }, () => this.loadData());
    };

    loadCountries = async () => {
        let response = await Request.getCountriesWithoutAuth({ results: 100, count: 100 });

        response.data = response.data.reduce((acc, vv) => {
            if (vv._id && vv.countryName) {
                acc[vv._id] = vv.countryName;
            }
            return acc;
        }, {});
        this.setState({ countries: response.data });
    }

    componentDidMount() {
        this.loadCountries();
    }

    loadData = async () => {
        const { time, viewType } = this.state;
        if (!time.from || !time.to || !viewType) return;

        this.setState({ loading: true });
        const params = { time, viewType };

        try {
            const response = await Request.getVisaApprovalReport(params);
            this.setState({
                report: response && response.data ? response.data : {},
                branchReport: null,
                loading: false
            });
        } catch (error) {
            this.setState({ loading: false, report: {} });
        }
    };

    loadBranchWiseData = async (period, typeView = "branch") => {
        this.setState({ loading: true, selectedPeriod: period });
        const params = { selectedPeriod: period, typeView: typeView };
        try {
            const response = await Request.getVisaApprovalReportBranches(params);
            this.setState({
                branchReport: response && response.data ? response.data : {},
                loading: false,
            });
        } catch (error) {
            this.setState({ loading: false, branchReport: {} });
        }
    }

    // loadStudentWiseApprovalReport = async (branchName) => {
    //     let { selectedPeriod } = this.state;
    //     let params = { selectedPeriod, branchName };
    //     this.setState({ exportParams: params, showStudentDrawer: true });
    // }

    loadStudentWiseApprovalReport = async (record) => {
        let { countries, selectedPeriod, typeView } = this.state;
        let branchName;
        if (record.countryName) {
            let countryId = null;

            countryId = Object.keys(countries).find(
                key => countries[key] === record.countryName
            );

            branchName = countryId;
        } else {
            branchName = record.branchName;
        }
        let params = { selectedPeriod, branchName, typeView }
        this.setState({ exportParams: params, showStudentDrawer: true });
    }

    render() {
        const { loading, report, viewType, branchReport, exportParams, showStudentDrawer, countries, typeView } = this.state;

        // Transform Main Timeline Data
        const tableData = report ? Object.entries(report).map(([period, count], index) => ({
            key: index,
            period,
            count
        })) : [];

        // Transform Branch Breakdown Data
        const branchTableData = branchReport ? Object.entries(branchReport).map(([branch, count], index) => ({
            key: `br-${index}`,
            branchName: branch,
            branchCount: count
        })) : [];

        const countryTableData = branchReport ? Object.entries(branchReport).map(([branch, count], index) => ({
            key: `br-${index}`,
            countryName: countries[branch],
            branchCount: count
        })) : [];

        // RESTORED: Calculate the total sum for the Statistic card
        const totalApprovedCount = tableData.reduce((sum, item) => sum + (Number(item.count) || 0), 0);

        const columns = [
            {
                title: "Period",
                dataIndex: "period",
                key: "period",
                render: (text) => {
                    let formatted = text;
                    if (/^\d{2}-\d{4}$/.test(text)) formatted = moment(text, "MM-YYYY").format("MMM-YYYY");
                    return <span style={{ fontWeight: 600 }}>{formatted}</span>;
                }
            },
            {
                title: "Visa Approvals",
                dataIndex: "count",
                key: "count",
                align: 'center',
                render: (count, record) => (
                    <Tooltip title="Click to view branch details">
                        <span onClick={() => this.loadBranchWiseData(record.period, "branch")} style={{ cursor: 'pointer' }}>
                            <Badge
                                count={count}
                                overflowCount={9999}
                                style={{ backgroundColor: '#52c41a', minWidth: '40px' }}
                            />
                        </span>
                    </Tooltip>
                )
            }
        ];

        const branchColumns = [
            { title: "Source", dataIndex: "branchName", key: "branchName" },
            {
                title: "Total Approved",
                dataIndex: "branchCount",
                key: "branchCount",
                align: 'center',
                render: (count, record) => (
                    <Tooltip title="Click to view student details">
                        <span onClick={() => this.loadStudentWiseApprovalReport(record)} style={{ cursor: 'pointer' }}>
                            <Badge count={count} overflowCount={9999} showZero style={{ backgroundColor: '#52c41a', minWidth: '40px' }} />
                        </span>
                    </Tooltip>
                )
            }
        ];

        const countryColumns = [
            { title: "Country", dataIndex: "countryName", key: "countryName" },
            {
                title: "Total Approved",
                dataIndex: "branchCount",
                key: "branchCount",
                align: 'center',
                render: (count, record) => (
                    <Tooltip title="Click to view student details">
                        <span onClick={() => this.loadStudentWiseApprovalReport(record)} style={{ cursor: 'pointer' }}>
                            <Badge count={count} overflowCount={9999} showZero style={{ backgroundColor: '#52c41a', minWidth: '40px' }} />
                        </span>
                    </Tooltip>
                )
            }
        ];




        return (
            <PageHeaderWrapper title="Visa Approval Report">
                {
                    showStudentDrawer && exportParams && (
                        <VisaApprovedStudents params={exportParams} onClose={() => this.setState({ showStudentDrawer: null, exportParams: null })} />
                    )
                }
                {/* FILTER BAR */}
                <Card
                    bordered={false}
                    style={{ marginBottom: 24, borderRadius: '8px', border: '1px solid #f0f0f0' }}
                    bodyStyle={{ padding: '16px 24px' }}
                >
                    <Row type="flex" align="middle" gutter={24}>
                        {/* Period Selection */}
                        <Col>
                            <div style={{ marginBottom: 4, fontSize: '12px', color: '#8c8c8c', fontWeight: 600 }}>PERIOD</div>
                            <RangePicker
                                format="YYYY-MM-DD"
                                onChange={this.chooseRangerPicker}
                                style={{ width: 280 }}
                            />
                        </Col>

                        {/* View Type Selection */}
                        <Col>
                            <div style={{ marginBottom: 4, fontSize: '12px', color: '#8c8c8c', fontWeight: 600 }}>VIEW TYPE</div>
                            <Select
                                value={viewType}
                                placeholder="Select View"
                                style={{ width: 160 }}
                                onChange={(v) => this.setState({ viewType: v }, () => this.loadData())}
                            >
                                {VIEW_TYPES.map(type => <Option key={type} value={type}>{type}</Option>)}
                            </Select>
                        </Col>

                        {/* Loading Indicator */}
                        <Col style={{ marginLeft: 'auto', paddingTop: '20px' }}>
                            {loading && <Spin indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />} />}
                        </Col>
                    </Row>
                </Card>

                {/* RESTORED: Summary Statistic Card */}
                {tableData.length > 0 && (
                    <Row gutter={16} style={{ marginBottom: 24 }}>
                        <Col span={6}>
                            <Card bordered={false} style={{ borderRadius: '8px', borderLeft: '4px solid #52c41a', background: 'linear-gradient(to right, #ffffff, #f6ffed)', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
                                <Statistic title={<span style={{ textTransform: 'uppercase', fontSize: '11px', letterSpacing: '0.5px' }}>Overall Approved Visas</span>} value={totalApprovedCount} prefix={<Icon type="safety-certificate" theme="filled" style={{ color: '#52c41a' }} />} />
                            </Card>
                        </Col>
                    </Row>
                )}

                {/* TIMELINE TABLE */}
                <Card bordered={false} style={{ marginBottom: 24, borderRadius: '8px' }}>
                    {!report && !loading ? (
                        <Empty description="Select range to view report" />
                    ) : (
                        <>
                            <div style={{
                                background: '#e6f7ff',
                                padding: '8px 12px',
                                borderRadius: '4px',
                                marginBottom: 16,
                                display: 'flex',
                                alignItems: 'center',
                                color: '#0050b3',
                                fontSize: '12px'
                            }}>
                                <Icon type="info-circle" theme="filled" style={{ marginRight: 8 }} />
                                <span>Click on the <b>Approved count</b> to see source list.</span>
                            </div>
                            {/* <div style={{ marginBottom: 12, color: '#8c8c8c', fontSize: '12px' }}><Icon type="info-circle" style={{ marginRight: 4 }} /> </div> */}
                            <TableComp columns={columns} dataSource={tableData} pagination={false} size="middle" />
                        </>

                    )}
                </Card>

                {/* BRANCH TABLE */}

                {branchReport && (
                    <Card
                        bordered={false}
                        style={{ borderRadius: '8px', border: '1px solid #e6f7ff', marginTop: 24 }}
                        title={
                            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                <Icon type="project" style={{ color: '#fff' }} />
                                <span style={{ fontWeight: 600, color: '#fff' }}>Detailed Breakdown</span>
                                <Divider type="vertical" />
                                <span style={{ fontSize: '12px', color: '#fff', fontWeight: 400 }}>
                                    Period: <b style={{ color: '#fff' }}>{this.state.selectedPeriod}</b>
                                </span>
                            </div>
                        }
                        extra={
                            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                                {/* Clean Segmented Control for View Switching */}
                                <div style={{ background: '#f5f5f5', padding: '2px', borderRadius: '6px', display: 'flex', alignItems: 'center' }}>
                                    <Button
                                        size="small"
                                        type={this.state.typeView === 'branch' ? 'primary' : 'link'}
                                        style={{ fontSize: '12px', borderRadius: '4px', boxShadow: this.state.typeView === 'branch' ? '0 2px 4px rgba(0,0,0,0.1)' : 'none' }}
                                        onClick={() => {
                                            this.setState({ typeView: 'branch' }, () => this.loadBranchWiseData(this.state.selectedPeriod, 'branch'));
                                        }}
                                    >
                                        Branch
                                    </Button>
                                    <Button
                                        size="small"
                                        type={this.state.typeView === 'country' ? 'primary' : 'link'}
                                        style={{ fontSize: '12px', borderRadius: '4px', boxShadow: this.state.typeView === 'country' ? '0 2px 4px rgba(0,0,0,0.1)' : 'none' }}
                                        onClick={() => {
                                            this.setState({ typeView: 'country' }, () => this.loadBranchWiseData(this.state.selectedPeriod, 'country'));
                                        }}
                                    >
                                        Country
                                    </Button>
                                </div>
                                <Icon
                                    type="close-circle"
                                    theme="filled"
                                    onClick={() => this.setState({ branchReport: null })}
                                    style={{ cursor: 'pointer', color: '#bfbfbf', fontSize: '18px' }}
                                />
                            </div>
                        }
                    >
                        <div style={{
                            background: '#e6f7ff',
                            padding: '8px 12px',
                            borderRadius: '4px',
                            marginBottom: 16,
                            display: 'flex',
                            alignItems: 'center',
                            color: '#0050b3',
                            fontSize: '12px'
                        }}>
                            <Icon type="info-circle" theme="filled" style={{ marginRight: 8 }} />
                            <span>Showing approvals by <b>{this.state.typeView
                                ? this.state.typeView.charAt(0).toUpperCase() + this.state.typeView.slice(1)
                                : ''}</b>. Click the count badge to view specific student details.</span>
                        </div>

                        <TableComp
                            columns={this.state.typeView === 'branch' ? branchColumns : countryColumns}
                            dataSource={this.state.typeView === 'branch' ? branchTableData : countryTableData}
                            pagination={false}
                            size="middle"
                            rowClassName="hover-row-highlight"
                        />
                    </Card>
                )}
            </PageHeaderWrapper>
        );
    }
}

const mapStateToProps = ({ global }) => ({ loading: global.buttonLoading });
export default connect(mapStateToProps)(VisaApprovalReport);